import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import PageValueObjectsFactory from '../../page/ValueObjects/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {TransactionsEntityFactory} from '../Entities/factory.js'
import {TransactionErrorsFactory} from '../Errors/factory.js'
import {TransactionsMappersFactory} from '../Mappers/factory.js'
import {TransactionsValueObjectsFactory} from '../ValueObjects/factory.js'
import {HTTPTransactionRepository} from './HTTPTransactionRepository.js'

export class TransactionsRepositoriesFactory {
  static httpTransactionRepository = ({config}) =>
    new HTTPTransactionRepository({
      buyerDataErrorsFactory: TransactionErrorsFactory.buyerDataError,
      calculatorPluginTransactionsValueObjectFactory:
        TransactionsValueObjectsFactory.calculatorPluginTransactionsValueObject,
      config,
      confirmAgreedPriceTransactionsErrorFactory: TransactionErrorsFactory.confirmAgreedPriceTransactionsError,
      createTradeTransactionsErrorFactory: TransactionErrorsFactory.createTradeTransactionsError,
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      fromRawDataToLoanCalculationEntityObjectTransactionsMapper:
        TransactionsMappersFactory.fromRawDataToLoanCalculationEntityObjectTransactionsMapper({config}),
      httpAuthenticationFetcher: FetcherFactory.httpAuthenticationFetcher({config}),
      getBuyerTradeDataTransactionsErrorFactory: TransactionErrorsFactory.getBuyerTradeDataTransactionsError,
      getTradeCostsListTransactionsError: TransactionErrorsFactory.getTradeCostsListTransactionsError,
      getSellerTradeDataTransactionsErrorFactory: TransactionErrorsFactory.getSellerTradeDataTransactionsError,
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      getProfessionalActivitiesTransactionsErrorFactory:
        TransactionErrorsFactory.getProfessionalActivitiesTransactionsError,
      getTradeCostsListTransactionsErrorFactory: TransactionErrorsFactory.getTradeCostsListTransactionsError,
      getTradeDataTransactionsErrorFactory: TransactionErrorsFactory.getTradeDataTransactionsError,
      informAgreedPriceTransactionsErrorFactory: TransactionErrorsFactory.informAgreedPriceTransactionsError,
      loanB2CEntityFactory: TransactionsEntityFactory.loanB2CEntity,
      loanCalculationsTransactionsValueObjectFactory:
        TransactionsValueObjectsFactory.loanCalculationsTransactionsValueObject,
      payOutErrorsFactory: TransactionErrorsFactory.payOutError,
      reservationEntity: TransactionsEntityFactory.reservationEntity,
      transactionEntity: TransactionsEntityFactory.transactionEntity,
      transactionErrorsFactory: TransactionErrorsFactory.transactionError,
      transactionNoContentErrorFactory: TransactionErrorsFactory.transactionNoContentError,
      updateBuyerTradeDataTransactionsErrorFactory: TransactionErrorsFactory.updateBuyerTradeDataTransactionsError,
      updateSellerTradeDataTransactionsErrorFactory: TransactionErrorsFactory.updateSellerTradeDataTransactionsError,
      uploadBuyerIdTransactionsErrorFactory: TransactionErrorsFactory.uploadBuyerIdTransactionsError,
      uploadSellerIdTransactionsErrorFactory: TransactionErrorsFactory.uploadSellerIdTransactionsError,
      urlValueObjectFactory: PageValueObjectsFactory.urlValueObject
    })
}
